<scope-roles-header
  *ngIf="roles?.length > 0 && !config?.isTimeline"
  [config]="config"
  [level]="level">
</scope-roles-header>

<ng-container *ngFor="let role of roles | orderBy: 'order'; trackBy: trackById">
  <scope-roles-row
    *ngIf="config?.isChangeRequest ? config?.showDiff || !role.isRemoved : true"
    [role]="role"
    [config]="config"
    [component]="component"
    [level]="level"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)">
  </scope-roles-row>
</ng-container>
